import { render, staticRenderFns } from "./wdpjList.vue?vue&type=template&id=adb8ca94&scoped=true&"
import script from "./wdpjList.vue?vue&type=script&lang=js&"
export * from "./wdpjList.vue?vue&type=script&lang=js&"
import style0 from "./wdpjList.vue?vue&type=style&index=0&id=adb8ca94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb8ca94",
  null
  
)

export default component.exports